import {Component, OnInit, Output, EventEmitter, Input} from '@angular/core';
import {AutoUnsubscribe} from '../../../../core/decorators/auto-unsubscribe';
import {GridDataResult} from '@progress/kendo-angular-grid';
import {GlobalsService} from '../../../../core/services/globals.service';
import {TranslateService} from '@ngx-translate/core';
import {AuthService} from '../../../../core/services/auth.service';
import {ConfirmService} from '../../../../shared/confirm/confirm.service';

@Component({
    selector: 'app-modal-orders',
    templateUrl: './modal-orders.component.html',
    styleUrls: ['./modal-orders.component.scss']
})

@AutoUnsubscribe()
export class ModalOrdersComponent implements OnInit {
    @Input() ordenesAbiCurCerr;
    @Input() pantalla: string;
    @Input() tipo: string;
    @Input() updateDetails: boolean = true;
    @Output() childModalClose = new EventEmitter<any>();
    error: string;
    code: string;
    facturada: string;
    anulada: string;
    abierta: string;
    cerrada: string;
    encurso: string;
    facturadaParc: string;
    pendienteFac: string;
    presupuestoAbi: string;
    presupuestoAcep: string;
    presupuestoCerra: string;
    reabierta: string;
    presupuesto_ci: string;
    presupuesto_encurso: string;
    presupuestoNo: string;
    reservado: string;
    selectedOrder: any = null;

    public pageSize: number;
    public pageNumber: number;
    public skip: number;
    hasPage: boolean;
    public gridView: GridDataResult;
    dataTable: any[] = [];
    title: string;

    constructor(
        private _globalsService: GlobalsService,
        private translate: TranslateService,
        private _confirmService: ConfirmService,
        public _authService: AuthService
    ) {
        this.skip = 0;
        this.pageNumber = 1;
        this.pageSize = 10;
        this.dataTable = [{
            title: 'gestion_vehiculos.popup.ordenesAbiertas',
            th: ['labels.num_doc', 'labels.fecha', 'labels.estado'],
            fields: ['orden', 'historicData', 'state'],
            format: ['', '', ''],
            width: ['', '', ''],
            height: ['150'],
            disabled: false
        }];
    }

    ngOnInit() {
        this.cargarTextos();
        this.rellenarTabla();
        this.checkTipo();
    }

    checkTipo() {
        switch (this.tipo) {
            case 'vehiculo':
                this.title = 'gestion_vehiculos.popup.ordenesVehiculo';
                break;
            case 'cliente':
                this.title = 'gestion_vehiculos.popup.ordenesCliente';
                break;
            case 'clienteVehiculo':
                this.title = 'gestion_vehiculos.popup.ordenesClienteVehiculo';
                break;
            default:
                this.title = 'gestion_vehiculos.popup.ordenesAbiertas';
                break;
        }
    }

    mostrarBotones(): boolean {
        if (this.pantalla === 'gestionForm' ||
            this.pantalla === 'edtDatosRecepcion' ||
            this.pantalla === 'gestion-terceros-register' ||
            this.pantalla === 'facturacion-manual' ||
            this.pantalla === 'autofacturas' ||
            this.pantalla === 'ventas-mostrador' ||
            this.pantalla === 'presupuestos-taller') {
            return true;
        } else {
            return false;
        }
    }

    cargarTextos() {
        this.translate.get('labels.facturada').subscribe(rest => (this.facturada = rest));
        this.translate.get('labels.anulada').subscribe(rest => (this.anulada = rest));
        this.translate.get('labels.abierta').subscribe(rest => (this.abierta = rest));
        this.translate.get('labels.cerrada').subscribe(rest => (this.cerrada = rest));
        this.translate.get('labels.encurso').subscribe(rest => (this.encurso = rest));
        this.translate.get('labels.facturada_parc').subscribe(rest => (this.facturadaParc = rest));
        this.translate.get('labels.pendiente_fact').subscribe(rest => (this.pendienteFac = rest));
        this.translate.get('labels.presupuesto_abi').subscribe(rest => (this.presupuestoAbi = rest));
        this.translate.get('labels.presupuesto_acep').subscribe(rest => (this.presupuestoAcep = rest));
        this.translate.get('genericos.tiposEstado.presupuestoCerra').subscribe(rest => (this.presupuestoCerra = rest));
        this.translate.get('labels.reabierta').subscribe(rest => (this.reabierta = rest));
        this.translate.get('labels.ciservice').subscribe(rest => (this.presupuesto_ci = rest));
        this.translate.get('labels.presupuesto_curso').subscribe(rest => (this.presupuesto_encurso = rest));
        this.translate.get('labels.presupuesto_no_acep').subscribe(rest => (this.presupuestoNo = rest));
        this.translate.get('labels.reservado').subscribe(rest => (this.reservado = rest));
    }

    rellenarTabla() {
        // fields: ['order', 'historicData','state']
        this.ordenesAbiCurCerr.forEach(item => {
            item.orden = item['Prefix'] + '-' + item['Number'];
            item.historicData = this._globalsService.getDateFormatMDY(item.Date);
            item.state = this.getFactTranslate(item['StatusCode']); // TODO: reemplazar por StatusDescription
        });


        this.dataTable[0]['gridView'] = {
            data: this.ordenesAbiCurCerr,
            total: this.ordenesAbiCurCerr.length
        };
    }

    getFactTranslate(faType) {
        switch (faType) {
            case 'AB':
                return this.abierta;
            case 'FA':
                return this.facturada;
            case 'AN':
                return this.anulada;
            case 'CC':
                return this.cerrada;
            case 'EC':
                return this.encurso;
            case 'FP':
                return this.facturadaParc;
            case 'RA':
                return this.reabierta;
            case 'PF':
                return this.pendienteFac;
            case 'PA':
                return this.presupuestoAbi;
            case 'PC':
                return this.presupuestoAcep;
            case 'CE':
                return this.presupuestoCerra;
            case 'PE':
                return this.presupuesto_encurso;
            case 'PN':
                return this.presupuestoNo;
            case 'PI':
                return this.presupuesto_ci;
            case 'RE':
                return this.reservado;

        }
    }

    closeModal(guardar) {
        const params = {
            guardado: guardar,
            datos: this.selectedOrder
        };

        if (guardar !== 'cerrar' && ((this.pantalla === 'edtDatosRecepcion' || this.pantalla === 'gestion-terceros-register') && this._authService.getDataPais() == 'es' && this.updateDetails)) {
            this.translate.get(['labels.aviso', 'labels.actualizar', 'labels.cancelar', 'gestion_terceros.popup.alertaIva']).subscribe(res => {
                this._confirmService.confirmConfig = {
                    title: res['labels.aviso'],
                    message: res['gestion_terceros.popup.alertaIva'],
                    textButtonAccept: res['labels.actualizar'],
                    textButtonCancel: res['labels.cancelar'],
                    onButtonAccept: () => {
                        this.childModalClose.emit(params);
                    },
                    onButtonCancel: () => {}
                }
                this._confirmService.showConfirm(true);
            });
        } else {
            this.childModalClose.emit(params);
        }
    }

    getRow(event) {
        this.selectedOrder = event.dataItem;
    }
}









